import getFreshSideObject from "./getFreshSideObject.js";
export default function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
// module id = 168
// module chunks = 0